import { createFileRoute } from "@tanstack/react-router";
import { loadLegacyContent, LegacyContent, legacyHead } from "@/lib/legacy-content";

export const Route = createFileRoute("/orthopaedics")({
  loader: () => loadLegacyContent("orthopaedics"),
  head: ({ loaderData }) =>
    loaderData ? legacyHead("/orthopaedics", loaderData) : { meta: [{ title: "Orthopaedics — Healic" }] },
  component: () => <LegacyContent payload={Route.useLoaderData()} />,
});
